'use client';

import { c as _c } from "react/compiler-runtime";
import { NavArrowDown } from '@byway/icons';
import { clsx } from 'clsx';
import { Button as RAC_Button, Disclosure as RAC_Disclosure, DisclosureGroup as RAC_DisclosureGroup, DisclosurePanel as RAC_DisclosurePanel } from 'react-aria-components';
import headingStyles from '~/components/Heading/src/Heading.module.css';
import colourStyles from '~/components/Utilities/ColourCombinations/ColourCombinations.module.css';
import styles from './Disclosure.module.css';
import type { DisclosureGroupProps, DisclosureProps } from './Disclosure.types';
export function DisclosureGroup(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = clsx(styles.group, className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <RAC_DisclosureGroup {...props} className={t1} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export function Disclosure(t0) {
  const $ = _c(46);
  let children;
  let headingVariant;
  let leadingElement;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let title;
  if ($[0] !== t0) {
    ({
      title,
      size: t1,
      leadingElement,
      showChevron: t2,
      headingLevel: t3,
      headingVariant,
      headerColour: t4,
      panelColour: t5,
      noBorder: t6,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = headingVariant;
    $[3] = leadingElement;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = title;
  } else {
    children = $[1];
    headingVariant = $[2];
    leadingElement = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    title = $[11];
  }
  const size = t1 === undefined ? "md" : t1;
  const showChevron = t2 === undefined ? true : t2;
  const HeadingEl = t3 === undefined ? "h2" : t3;
  const headerColour = t4 === undefined ? "defaultBackground" : t4;
  const panelColour = t5 === undefined ? "defaultBackground" : t5;
  const noBorder = t6 === undefined ? false : t6;
  const headerBg = headerColour && colourStyles[headerColour];
  const panelBg = panelColour && colourStyles[panelColour];
  const t7 = noBorder && styles.noBorder;
  let t8;
  if ($[12] !== t7) {
    t8 = clsx(styles.disclosure, t7);
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== headerBg) {
    t9 = clsx(headerBg, styles.heading);
    $[14] = headerBg;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = styles[size];
  let t11;
  if ($[16] !== t10) {
    t11 = clsx(styles.trigger, t10);
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== leadingElement) {
    t12 = leadingElement && <span className={styles.leadingElement}>{leadingElement}</span>;
    $[18] = leadingElement;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const t13 = headingVariant && headingStyles[headingVariant];
  let t14;
  if ($[20] !== t13) {
    t14 = clsx(styles.titleText, t13);
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t14 || $[23] !== title) {
    t15 = <span className={t14}>{title}</span>;
    $[22] = t14;
    $[23] = title;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== showChevron) {
    t16 = showChevron && <NavArrowDown decorative={true} className={styles.chevron} />;
    $[25] = showChevron;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t11 || $[28] !== t12 || $[29] !== t15 || $[30] !== t16) {
    t17 = <RAC_Button slot="trigger" className={t11}>{t12}{t15}{t16}</RAC_Button>;
    $[27] = t11;
    $[28] = t12;
    $[29] = t15;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== HeadingEl || $[33] !== t17 || $[34] !== t9) {
    t18 = <HeadingEl className={t9}>{t17}</HeadingEl>;
    $[32] = HeadingEl;
    $[33] = t17;
    $[34] = t9;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== panelBg) {
    t19 = clsx(panelBg, styles.panel);
    $[36] = panelBg;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== children || $[39] !== t19) {
    t20 = <RAC_DisclosurePanel className={t19}>{children}</RAC_DisclosurePanel>;
    $[38] = children;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== props || $[42] !== t18 || $[43] !== t20 || $[44] !== t8) {
    t21 = <RAC_Disclosure {...props} className={t8}>{t18}{t20}</RAC_Disclosure>;
    $[41] = props;
    $[42] = t18;
    $[43] = t20;
    $[44] = t8;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  return t21;
}